<script>
import {ProductCategorySelect} from "@core/components/product";

export default {
    components: {ProductCategorySelect},
    props: {
        selected: {
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            value: this.selected.map(item => item.property)
        }
    },
    methods: {
        onChange({idList, items}) {
            this.$emit("input", items.map(i => i.category));
        }
    },
    watch: {
        selected() {
            this.value = this.selected.map(item => item.property);
        }
    }
}
</script>

<template>
    <ProductCategorySelect
        :only-selectable="false"
        :selected-items="value"
        @change="onChange"
    />
</template>
